<template>
    <div class="backpage" @click="goBack">
        <!-- <el-icon>
            <Back />
        </el-icon> -->
        ← 返回上一级
    </div>
    <div class="installt">
        <div class="intext">商品详情</div>
        <div class="addpoper" @click="yongshow">

            <div style="height: 24px;">修改佣金基数</div>
        </div>
    </div>
    <div class="goddsmsg">
        <div class="goodsnub">
            <div class="goodstate">
                <div class="goodhead">
                    <div class="goodimg">
                        <img :src="images(onboimg)" alt="">
                    </div>
                    <div class="goodname">
                        <div class="name"> {{ godmessages.pname }}</div>
                        <div class="lei">{{ fenleis(godmessages.className) }}</div>
                        <div class="price">¥ {{ godmessages.pprice || '0' }}</div>
                    </div>
                    <div class="goodfen">
                        <div class="huod">
                            秒杀中
                        </div>
                        <div class="fen">
                            <el-icon color="#FF2828">
                                <StarFilled />
                            </el-icon>5.0
                        </div>
                        <div class="pingjia">
                            商品评价
                        </div>
                    </div>
                </div>
                <div class="goodspai">
                    <div class="pai">
                        <div class="pait">品牌</div>
                        <div class="paib"> {{ godmessages.brandName || '未知' }} </div>
                    </div>
                    <div class="pai">
                        <div class="pait">商品分类</div>
                        <div class="paib">{{ fenleis(godmessages.className) }}</div>
                    </div>
                    <div class="pai">
                        <div class="pait">商品编号</div>
                        <div class="paib">{{ godmessages.pid }}</div>
                    </div>
                    <div class="pai">
                        <div class="pait">库存数</div>
                        <div class="paib">{{ godmessages.pquantity }}</div>
                    </div>
                    <div class="pai">
                        <div class="pait">佣金基数(社交)</div>
                        <div class="paib">{{ jishuyong }}</div>
                    </div>
                </div>
            </div>
            <div class="zhuimg">
                <div class="zhuimgtop">
                    商品主图
                </div>
                <div class="imgs">
                    <div class="imgas" v-if="lunboimg.length < 1">

                        <div class="wuimg">
                            <img src="../../assets/goodlist/wuimg.png" alt="">
                        </div>
                        <div class="wutet">暂无图片</div>
                    </div>

                    <div v-else class="imgas" v-for="(item, index) in lunboimg" :key="index">
                        <img :src="images(item)" alt="">
                    </div>

                    <!--  -->

                </div>



            </div>
            <div class="zong">
                <div class="zongshu">总数据</div>
                <div class="zongyuan">
                    <div class="zongs">
                        <div class="zongss">净销售额(元)</div>
                        <div class="zongse">{{ godmessages.salesNum * godmessages.pprice || 0 }}</div>
                    </div>
                    <div class="zongs" style="margin-left: 8px;">
                        <div class="zongss">订单</div>
                        <div class="zongse">{{ godmessages.salesNum || 0 }}</div>
                    </div>
                </div>
                <div class="zongyuan">
                    <div class="zongs">
                        <div class="zongss">关注数(人)</div>
                        <div class="zongse">{{ godmessages.collectionNum || 0 }}</div>
                    </div>
                    <div class="zongs" style="margin-left: 8px;">
                        <div class="zongss">商品退换率</div>
                        <div class="zongse">0</div>
                    </div>

                </div>

            </div>
        </div>
        <div class="kongbai"></div>
        <div class="goodslook">
            <div class="looktop">
                <div class="bioa">
                    转化详情
                </div>
                <div class="choosedata">
                    <!-- <div>统计时间</div> -->
                    <div></div>

                </div>
            </div>
            <div class="Conversion">
                <div class="biaotu">
                    <div class="tiaoyi shu1"></div>
                    <div class="npbai">
                        <div> <el-icon size="24" color="#999999">
                                <Bottom />
                            </el-icon></div>
                        <div>{{ Percentage2 }}</div>
                    </div>
                    <div class="tiaoyi shu2" :style="{ 'width': Percentage2 }"></div>
                    <div class="npbai">
                        <div> <el-icon size="24" color="#999999">
                                <Bottom />
                            </el-icon></div>
                        <div>{{ Percentage3 }}</div>

                    </div>
                    <div class="tiaoyi shu3" :style="{ 'width': Percentage3 }"></div>
                    <div class="npbai">
                        <div> <el-icon size="24" color="#999999">
                                <Bottom />
                            </el-icon></div>
                        <div>{{ Percentage4 }}</div>
                    </div>
                    <div class="tiaoyi shu4" :style="{ 'width': Percentage4 }"></div>
                </div>
                <div class="goodsbai">
                    <div class="goodsw">
                        <div class="goodsw1">1 &nbsp; <span style="font-size: 14px;color: #202020;"> 查看商品</span></div>
                        <div class="goodsw2">100% </div>
                        <div class="goodsw3">
                            <div class="swshu">浏览人数</div>
                            <div class="swshu2">{{ godmessages.lookPv || 0 }}</div>
                        </div>
                        <div class="goodsw3">
                            <div class="swshu">访问量</div>
                            <div class="swshu2">{{ godmessages.lookPv || 0 }}</div>
                        </div>
                        <div class="goodsw3">
                            <div class="swshu">人均访问次数</div>
                            <div class="swshu2">暂无数据</div>
                        </div>
                    </div>
                    <div class="xian"></div>
                    <div class="goodsw">
                        <div class="goodsw1">2 &nbsp; <span style="font-size: 14px;color: #202020;"> 查看详情</span></div>
                        <div class="goodsw2">{{ divideAndFormatPercentage(godmessages.lookPv, godmessages.lookUv, 2) }}
                        </div>
                        <div class="goodsw3">
                            <div class="swshu">详情人数</div>
                            <div class="swshu2">{{ godmessages.lookUv || 0 }}</div>
                        </div>
                        <div class="goodsw3">
                            <div class="swshu">详情访问量</div>
                            <div class="swshu2">{{ godmessages.lookUv || 0 }}</div>
                        </div>
                        <div class="goodsw3">
                            <div class="swshu">人均访问详情次数</div>
                            <div class="swshu2">暂无数据</div>
                        </div>
                    </div>
                    <div class="xian"></div>
                    <div class="goodsw">
                        <div class="goodsw1">3 &nbsp; <span style="font-size: 14px;color: #202020;"> 加购</span></div>
                        <div class="goodsw2">{{ divideAndFormatPercentage(godmessages.lookPv, godmessages.cartPv, 3) }}
                        </div>
                        <div class="goodsw3">
                            <div class="swshu">加购人数</div>
                            <div class="swshu2">{{ godmessages.cartPv || 0 }}</div>
                        </div>
                        <div class="goodsw3">
                            <div class="swshu">加购商品量</div>
                            <div class="swshu2">{{ godmessages.cartPv || 0 }}</div>
                        </div>
                        <div class="goodsw3">
                            <div class="swshu">人均加购数量</div>
                            <div class="swshu2">暂无数据</div>
                        </div>
                    </div>
                    <div class="xian"></div>
                    <div class="goodsw">
                        <div class="goodsw1">4 &nbsp; <span style="font-size: 14px;color: #202020;"> 下单</span></div>
                        <div class="goodsw2">{{ divideAndFormatPercentage(godmessages.lookPv, godmessages.cartUv, 4) }}
                        </div>
                        <div class="goodsw3">
                            <div class="swshu">下单人数</div>
                            <div class="swshu2">{{ godmessages.cartUv || 0 }}</div>
                        </div>
                        <div class="goodsw3">
                            <div class="swshu">下单商品量</div>
                            <div class="swshu2">{{ godmessages.cartUv || 0 }}</div>
                        </div>
                        <div class="goodsw3">
                            <div class="swshu">人均下单金额</div>
                            <div class="swshu2">暂无数据</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <el-dialog v-model="openfahuonow" title="提示" width="500">
        <div style="display: flex;align-items: center;">
            <span>佣金设置:&nbsp;&nbsp;</span>
            <el-checkbox-group v-model="checkList" @change="chgroup">
                <el-checkbox label="社交媒体" value="社交媒体" />
                <el-checkbox label="视频平台" value="视频平台" />
            </el-checkbox-group>

        </div>

        <br>
        <div style="margin-top: 20px;">

            <span>社交媒体佣金比例:</span> &nbsp; <el-input type="number" :max="1" :min="0" @blur="numchan(meiti, 1)"
                v-model="meiti" style="width: 240px" placeholder="社交媒体佣金比例" />
        </div>
        <div style="margin-top: 20px;">

            <span>视频平台佣金比例:</span> &nbsp; <el-input type="number" :max="1" :min="0" @blur="numchan(videobi, 2)"
                v-model="videobi" style="width: 240px" placeholder="视频平台佣金比例" />
        </div>

        <template #footer>
            <div class="dialog-footer">
                <el-button @click="openfahuonow = false">取消</el-button>
                <el-button type="primary" @click="kuaidfahuo">
                    确定
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script setup>
import api from '@/api/api';
import { onMounted, defineProps, reactive, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { ElMessage } from 'element-plus'
const route = useRoute()
const commit = route.query.commit
const pid = route.query.pid
const godmessages = ref({})
let lunboimg = ref([])
let onboimg = ref(null)
let openfahuonow = ref(false)
const checkList = ref([])
let meiti = ref(null)
let videobi = ref(null)
let jishuyong = ref(0)
let amountRatio = []
const chgroup = (e) => {
    console.log(e)
}

onMounted(() => {
    productInfo()
})

const numchan = (nub, val) => {
    if (val == 1) {
        if (nub > 1) {
            meiti.value = 1
        } else if (nub < 0) {
            meiti.value = 0
        }
    } else {
        if (nub > 1) {
            videobi.value = 1
        } else if (nub < 0) {
            videobi.value = 0
        }
    }

}
watch(checkList, (newValue, oldValue) => {
    console.log(newValue, oldValue)
})
const kuaidfahuo = async () => {
    let accessType
    let kickbackAmountRatio = []
    if (checkList.value.length == 2) {
        accessType = "0,1"
        kickbackAmountRatio = [
            {
                "accessType": 0,
                "amount": (godmessages.value.pprice * meiti.value).toFixed(2),
                "extraAmount": 0,
                "extraRatio": Number(meiti.value),
                "ratio": 0
            },
            {
                "accessType": 1,
                "amount": (godmessages.value.pprice * videobi.value).toFixed(2),
                "extraAmount": 0,
                "extraRatio": Number(videobi.value),
                "ratio": 0
            }
        ]
    } else {
        // console.log(checkList[0])
        if (checkList.value[0] == '社交媒体') {
            accessType = "0"
            kickbackAmountRatio = [
                {
                    "accessType": 0,
                    "amount": (godmessages.value.pprice * meiti.value).toFixed(2),
                    "extraAmount": 0,
                    "extraRatio": Number(meiti.value),
                    "ratio": 0
                }
            ]
        } else {
            accessType = "1"
            kickbackAmountRatio = [

                {
                    "accessType": 1,
                    "amount": (godmessages.value.pprice * videobi.value).toFixed(2),
                    "extraAmount": 0,
                    "extraRatio": Number(videobi.value),
                    "ratio": 0
                }
            ]
        }
    }

    let data = {
        "accessType": accessType,
        "kickbackAmountRatio": kickbackAmountRatio,
        "productId": godmessages.value.pid,
        "productPrice": godmessages.value.pprice,
        "storeId": 77
    }
    console.log(data)

    const res = await api.kickback(data)
    if (res.success) {
        ElMessage({
            message: '佣金设置成功',
            type: 'success',
            onClose: () => {
                openfahuonow.value = false
                location.reload()
            }
        })
    } else {
        ElMessage.error('佣金设置失败！')
    }
}
const yongshow = () => {
    openfahuonow.value = true
    if (amountRatio.length == 2) {
        console.log('amountRatio', amountRatio)
        checkList.value = ['社交媒体', '视频平台']
        for (let a = 0; a < amountRatio.length; a++) {

            if (amountRatio[a].accessType == 0) {
                // checkList.value.push('社交媒体')
                meiti.value = amountRatio[a].extraRatio

            }
            if (amountRatio[a].accessType == 1) {
                // checkList.value.push('社交媒体')
                videobi.value = amountRatio[a].extraRatio
            }
        }

    } else if (amountRatio.length == 1) {
        console.log('amountRatio', amountRatio)
        if (amountRatio[0].accessType == 0) {
            checkList.value.push('社交媒体')
            meiti.value = amountRatio[0].extraRatio

        } else {
            checkList.value.push('视频平台')
            videobi.value = amountRatio[0].extraRatio

        }
    }
}
const fenleis = (str) => {
    console.log(str)
    if (str) {
        const arr = str.split("/");
        console.log(arr);
        if (arr.length > 1) {
            arr.splice(0, 1)
        }
        const stre = arr.join("/");
        return stre

    } else {
        return '暂无分类'
    }

}
const productInfo = async () => {
    // console.log(pid,commit)

    let data = {
        productId: pid,
        storeId: commit
    }
    const res = await api.productInfo(data)
    // console.log('godmessages',res.data)

    godmessages.value = res.data
    if (godmessages.value.amountRatio) {

        godmessages.value.amountRatio = godmessages.value.amountRatio
        amountRatio = godmessages.value.amountRatio
        for (let a = 0; a < godmessages.value.amountRatio.length; a++) {

            if (godmessages.value.amountRatio[a].accessType == 0) {
                jishuyong.value = godmessages.value.amountRatio[a].extraRatio
            }

        }
    } else {

    }

    console.log('godmessages', godmessages.value)

    onboimg.value = godmessages.value.ppreviewpic[0]
    if (res.data.carouselImg > 6) {
        lunboimg.value = res.data.carouselImg.splice(0, 6)

    } else {
        lunboimg.value = res.data.carouselImg

    }
}

let Percentage2 = ref(0)
let Percentage3 = ref(0)
let Percentage4 = ref(0)

function divideAndFormatPercentage(dividend, divisor, nub) {
    if (dividend || divisor) {
        let result = (dividend / divisor) * 100;
        result = result.toFixed(2);
        result += '%';
        if (nub == 2) {
            Percentage2.value = result
        } else if (nub == 3) {
            Percentage3.value = result

        } else if (nub == 4) {
            Percentage4.value = result

        }
        return result;
    } else {
        if (nub == 2) {
            Percentage2.value = '0%'
        } else if (nub == 3) {
            Percentage3.value = '0%'

        } else if (nub == 4) {
            Percentage4.value = '0%'

        }
        return '0%';
    }

}
const goBack = () => {
    window.history.back();
}
const images = (face) => {
    // console.log(face)

    if (face) {
        const regex = /"(.*?)"/;
        const result = face.match(regex);
        // 输出提取的字符
        if (result && result[1]) {
            if (result[1].startsWith('http')) {
                return result[1]
            } else {
                if (result[1].startsWith('/')) {
                    return 'http://www.daomenkou.cn' + result[1]

                } else {
                    return 'http://www.daomenkou.cn/' + result[1]

                }
            }
        } else {
            console.log('未找到匹配的字符串');

            if (face.startsWith('http')) {
                return face
            } else {
                return 'http://www.daomenkou.cn/' + face
            }
        }
    } else {
        return require('../../assets/shop/morentx.png')
    }

}
</script>

<style lang="scss" scoped>
.backpage {
    margin-top: -20px;
    font-size: 16px;
    color: #3F8CFF;
    cursor: pointer;
    height: 20px;
}

.installt {
    width: 1164px;
    display: flex;
    height: 52px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 36px;
        font-weight: 400;
        color: #0A1629;
    }

    .addpoper {
        width: 132px;
        height: 48px;
        background: rgba(63, 140, 255);
        box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
        border-radius: 8px;
        color: #FFFFFF;
        cursor: pointer;
        padding-left: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
    }

}

.goddsmsg {
    width: 100%;
    height: calc(100% - 52px - 11px);
    margin-top: 23px;

    .goodsnub {
        width: 1157px;
        display: flex;
        // background-color: #3F8CFF;

        .goodstate {
            width: 415px;
            height: 263px;
            background: #FFFFFF;
            border-radius: 8px;
            padding: 28px 15px 0 29px;
            box-sizing: border-box;

            .goodhead {
                height: 116px;
                width: 368px;
                padding-bottom: 21px;
                box-sizing: border-box;
                border-bottom: 1px solid rgba(32, 32, 32, 0.06);
                // display: flex;

                .goodimg {
                    float: left;
                    width: 88px;
                    height: 88px;
                    border-radius: 8px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .goodname {
                    width: 128px;
                    margin-left: 13px;
                    text-align: left;
                    float: left;

                    .name {
                        width: 100%;
                        font-weight: 400;
                        font-size: 16px;
                        color: #111827;
                        line-height: 28px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;

                    }

                    .lei {
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        height: 22px;
                        margin-top: 8px;

                        font-weight: 400;
                        font-size: 14px;
                        color: #718096;
                        line-height: 22px;
                    }

                    .price {
                        margin-top: 5px;
                        height: 24px;

                        font-weight: 400;
                        font-size: 16px;
                        color: #E02020;
                        line-height: 24px;
                    }

                }

                .goodfen {
                    float: right;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;

                    .huod {

                        margin-top: 5px;
                        width: 42px;
                        height: 19px;
                        background: #E02020;
                        border-radius: 12px;
                        font-weight: 400;
                        font-size: 10px;
                        color: #FFFFFF;
                        line-height: 19px;
                        text-align: center;
                    }

                    .fen {
                        margin-top: 13px;
                        height: 17px;
                        font-weight: 500;
                        font-size: 16px;
                        color: #E02020;
                        line-height: 17px;
                    }

                    .pingjia {
                        height: 22px;

                        font-weight: 400;
                        font-size: 14px;
                        color: #718096;
                        line-height: 22px;
                        margin-top: 10px;
                    }

                }

            }

            .goodspai {
                display: flex;
                justify-content: space-around;
                padding-top: 28px;
                box-sizing: border-box;

                .pai {
                    // text-align: center;

                    .pait {
                        height: 16px;
                        font-weight: 400;
                        font-size: 12px;
                        color: #0A1629;
                        line-height: 16px;

                    }

                    .paib {
                        width: 70px;
                        margin-top: 21px;
                        height: 20px;
                        font-weight: 400;
                        font-size: 14px;
                        color: #000000;
                        line-height: 20px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                }
            }
        }

        .zhuimg {
            width: 327px;
            height: 263px;
            background: #FFFFFF;
            border-radius: 8px;
            margin-left: 25px;
            padding: 24px 0px 0 22px;
            box-sizing: border-box;

            .zhuimgtop {
                font-weight: 400;
                font-size: 16px;
                color: #000000;
            }

            .imgs {
                display: flex;
                flex-wrap: wrap;

                .imgas {
                    width: 88px;
                    height: 88px;
                    border-radius: 8px;
                    margin-right: 10px;
                    overflow: hidden;
                    margin-top: 8px;
                    background: #F9FAFB;

                    .wuimg {
                        width: 51px;
                        height: 46px;
                        margin: 11px auto 4px;
                    }

                    .wutet {
                        width: 100%;
                        text-align: center;
                        font-weight: 400;
                        font-size: 10px;
                        color: #000000;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }

        .zong {
            width: 371px;
            height: 263px;
            background: #FFFFFF;
            border-radius: 8px;
            margin-left: 16px;
            padding: 24px 25px 0 22px;
            box-sizing: border-box;

            .zongshu {
                font-weight: 400;
                font-size: 16px;
                color: #000000;
                margin-bottom: 10px;
            }

            .zongyuan {
                display: flex;

                .zongs {
                    width: 158px;
                    height: 90px;
                    border-radius: 8px;
                    background: #FAFAFA;
                    margin-top: 8px;
                    padding: 10px 0 0 12px;
                    box-sizing: border-box;

                    .zongss {
                        height: 16px;

                        font-size: 10px;
                        color: #718096;
                        line-height: 16px;
                    }

                    .zongse {
                        margin-top: 18px;
                        height: 27px;

                        font-weight: bold;
                        font-size: 18px;
                        color: #111827;
                        line-height: 27px;
                    }
                }

            }

        }

    }

    .kongbai {
        height: calc(100% - 263px - 367px - 23px);
    }

    .goodslook {
        // margin-top: 27px;
        width: 1157px;
        height: 367px;
        background: #FFFFFF;
        border-radius: 8px;
        padding: 25px 20px 0 20px;
        box-sizing: border-box;

        .looktop {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .bioa {


                font-size: 16px;
                color: #202020;
            }

            .choosedata {
                height: 15px;


                font-size: 12px;
                color: #202020;
                display: flex;
                align-items: center;
            }
        }

        .Conversion {
            display: flex;
            margin-top: 23px;

            .biaotu {
                width: 441px;
                height: 276px;
                // background-color: #c7c9ce;
                display: flex;
                flex-direction: column;
                align-items: center;

                .tiaoyi {
                max-width: 441px;
                    width: 100%;
                    height: 36px;
                    border-radius: 8px;
                }

                .shu1 {
                    background: #EBF3FF;
                    box-shadow: 0px 12px 12px 0px rgba(26, 117, 234, 0.15);
                    border: 1px solid #EBF3FF;

                }

                .shu2 {

                    background: #B8CFFF;
                    box-shadow: 0px 12px 12px 0px rgba(26, 117, 234, 0.15);
                    border: 1px solid #B8CFFF;

                }

                .shu3 {
                    background: #568CFB;
                    box-shadow: 0px 12px 12px 0px rgba(26, 117, 234, 0.15);
                    border: 1px solid #568CFB;

                }

                .shu4 {
                    background: #3D7EFF;
                    box-shadow: 0px 12px 12px 0px rgba(26, 117, 234, 0.15);
                    border: 1px solid #3D7EFF;

                }

                .npbai {
                    height: 24px;
                    font-size: 16px;
                    color: #111111;
                    line-height: 24px;
                    display: flex;
                    align-items: center;
                    margin: 10px 0 10px 0;
                }
            }

            .goodsbai {
                margin-left: 24px;

                .goodsw {
                    display: flex;
                    height: 37px;
                    align-items: center;

                    .goodsw1 {
                        width: 80px;
                        font-size: 16px;
                        color: #186DF5;
                        margin-right: 27px;
                    }

                    .goodsw2 {
                        width: 121px;
                        margin-right: 20px;
                        font-size: 24px;
                        color: #202020;

                    }

                    .goodsw3 {
                        width: 121px;
                        margin-right: 21px;

                        .swshu {
                            font-size: 14px;
                            color: #858585;
                        }

                        .swshuw {
                            font-size: 16px;
                            color: #202020;
                        }

                    }
                }

                .xian {
                    width: 530px;
                    height: 1px;
                    background: rgba(32, 32, 32, 0.05);
                    margin: 18px 0 21px 109px;
                }



            }
        }
    }
}
</style>